import { createSvgIcon } from "@mui/material/utils";

// MUI ships AddHome but no "remove" counterpart; this reuses its house path with a minus badge.
const GtRemoveHomeIcon = createSvgIcon(
  [
    <path
      key="house"
      d="M18 11c.7 0 1.37.1 2 .29V9l-8-6-8 6v12h7.68c-.43-.91-.68-1.92-.68-3 0-3.87 3.13-7 7-7"
    />,
    <path
      key="minus"
      d="M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m3 5.5h-6v-1h6z"
    />,
  ],
  "RemoveHome"
);

export default GtRemoveHomeIcon;
